module.exports = __webpack_public_path__ + "static/surgeon-e632fd29715ecf4a05efc0834f4e0cea.jpg";